module.exports = "../css/app.css";


//////////////////
// WEBPACK FOOTER
// ./src/scss/app.scss
// module id = 140
// module chunks = 0